"use client";

import Image from "next/image";
import styles from "../../../styles/pages/Blogs.module.scss";
import Link from "next/link";

import {
  FacebookIcon,
  FacebookShareButton,
  InstagramIcon,
  InstapaperShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "next-share";

import { FaLink } from "react-icons/fa";
import { useState } from "react";

import BookNowButtonWhite from "../../../components/BestDeal/BookNowButtonWhite";

export default function BlogDetail({ blog, Allblogs }) {
  const filteredBlogs = Allblogs.filter((item) => item.slug !== blog.slug);

  const similar_blogs = filteredBlogs;

  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      const fullUrl = window.location.href;

      await navigator.clipboard.writeText(fullUrl);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      {/* Blog Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              "@context": "https://schema.org",
              "@type": "BlogPosting",

              mainEntityOfPage: {
                "@type": "WebPage",
                "@id": `https://www.hoteltwintowers.com/blogs/${blog.slug}`,
              },

              headline: blog.blog_title || blog.title,

              description: blog.metaDesc || blog.shortDescription || "",

              image: `https://www.hoteltwintowers.com${
                blog.bannerImage || blog.bgImage
              }`,

              author: {
                "@type": "Organization",
                name: "The Twin Towers Hotel Kufri",
                url: "https://www.hoteltwintowers.com",
              },

              publisher: {
                "@type": "Organization",
                name: "The Twin Towers Hotel Kufri",
                url: "https://www.hoteltwintowers.com",

                logo: {
                  "@type": "ImageObject",
                  url: "https://www.hoteltwintowers.com/icons/logo.svg",
                },
              },

              datePublished: blog.date,
              dateModified: blog.date,

              keywords: blog.metaKeywords,

              url: `https://www.hoteltwintowers.com/blogs/${blog.slug}`,
            },

            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",

              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "The Twin Towers Hotel Kufri",
                  item: "https://www.hoteltwintowers.com/",
                },

                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Blogs",
                  item: "https://www.hoteltwintowers.com/blogs",
                },

                {
                  "@type": "ListItem",
                  position: 3,
                  name: blog.blog_title || blog.title,
                  item: `https://www.hoteltwintowers.com/blogs/${blog.slug}`,
                },
              ],
            },
          ]),
        }}
      />

      {/* Top Banner */}
      <section className={styles.single_blog_top_banner}></section>

      {/* Blog Content */}
      <section className={`${styles.single_blog} common_padding`}>
        <div className="container">
          <div className="row">
            {/* Main Blog */}
            <div className="col-12 col-sm-12 col-md-8 col-lg-8">
              <div className={styles.single_blog_page_top}>
                <p className="text-left">Publish on: {blog.date}</p>

                <h1>{blog.title}</h1>

                <div className={`${styles.blog_social_links_parent} d-flex`}>
                  {/* Categories */}
                  <div
                    className={`${styles.single_blog_destinations_btn} d-flex`}
                  >
                    <button>Shimla</button>
                    <button>Kufri</button>
                    <button>Things To Do</button>
                  </div>

                  {/* Social Share */}
                  <div>
                    Share On:
                    <div className={`${styles.blog_page_social_links} d-flex`}>
                      <FacebookShareButton
                        url={`https://www.hoteltwintowers.com/blogs/${blog.slug}`}
                      >
                        <FacebookIcon size={32} round />
                      </FacebookShareButton>

                      <InstapaperShareButton
                        url={`https://www.hoteltwintowers.com/blogs/${blog.slug}`}
                      >
                        <InstagramIcon size={32} round />
                      </InstapaperShareButton>

                      <WhatsappShareButton
                        url={`https://www.hoteltwintowers.com/blogs/${blog.slug}`}
                      >
                        <WhatsappIcon size={32} round />
                      </WhatsappShareButton>

                      {/* Copy Link */}
                      <div
                        className={styles.link_icon}
                        onClick={handleCopyLink}
                      >
                        {copied && <span>Copied!</span>}

                        <FaLink />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Blog HTML Content */}
              <div
                className={styles.blog_text1}
                dangerouslySetInnerHTML={{
                  __html: blog.content,
                }}
              ></div>
            </div>

            {/* Sidebar */}
            <div
              className={`${styles.recent_blog_sec} col-12 col-sm-12 col-md-4 col-lg-4`}
            >
              <div className={styles.sticky_recent_posts}>
                <div className={styles.recent_top}>
                  <h3 className="text-white">Recent Posts</h3>
                </div>

                <div className={styles.recent_bottom}>
                  {similar_blogs &&
                    similar_blogs.slice(0, 5).map((item) => (
                      <Link
                        href={`/blogs/${item.slug}`}
                        key={item.slug}
                        className={styles.recent_bottom_main}
                      >
                        <div>
                          <Image
                            src={item.bgImage}
                            alt={item.title}
                            width={70}
                            height={70}
                          />
                        </div>

                        <div className={styles.recent_bottom_right}>
                          <p>{item.date}</p>

                          <h6 className="m-0">{item.title}</h6>
                        </div>
                      </Link>
                    ))}
                </div>
              </div>

              {/* Booking Image */}
              <div className={styles.recent_blog_bottom_img_sec}>
                <div className={styles.recent_blog_bottom_img}>
                  <Image
                    src="/images/recent-blog-bottom.png"
                    fill
                    sizes="(max-width: 767px)100vw, 50vw"
                    style={{ objectFit: "cover" }}
                    alt="Experience The Twin Towers Hotel"
                  />
                </div>

                <div className={styles.recent_blog_bottom_img_content}>
                  <h4>
                    Experience
                    <br />
                    Breathtaking Mornings!
                  </h4>

                  <BookNowButtonWhite />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <footer>
        <div className={styles.blog_footer}>
          <div className={styles.blog_footer_content}>
            <h4>Your Perfect Stay Awaits</h4>

            <BookNowButtonWhite />
          </div>
        </div>
      </footer>
    </>
  );
}
